'use strict';

import {gsap} from 'gsap';
import 'scrollTo';

import Loader from '../../../_modules/loader/loader';

import { debounce, isFieldEmpty, isFieldSame, isDobEmpty, isValidEmail, displayErrors, displayInputError, isValidDob, goToNextSection, toggleProgressBar } from './_helper';
import { toaster } from './_material';

let $header = $('.header'),
    $register = $('.register__page'),
    $hcpFirstName = $('#HcpFirstName'),
    $hcpLastName = $('#HcpLastName'),
    $hcpDobDay = $('#DobDay'),
    $hcpDobMonth = $('#DobMonth'),
    $hcpDobYear = $('#DobYear'),
    $hcpGender = $('#HcpGender'),
    $hcpPrimaryNumber = $('#HcpPrimaryNumber'),
    $hcpPassword = $('#HcpPassword'),
    $hcpVerifyPassword = $('#HcpVerifyPassword'),
    $requiredInputs = $('.form--register-hcp input'),
    $searchWrapper = $('.select-institute__search'),
    $agreePrivacy = $('#AgreePrivacy'),
    $registerHcpForm = $('.form--register-hcp'),
    isAnim = false,
    sectionInd = 1,
    _isInvalid = [],
    dobParams,
    dataParams = {};

$(() => {
    if (!$register.length) {
        return false;
    }

    // Put Loader in a variable
    let loader = new Loader();

    /* HCP DETAILS validation.
    ** If succsessful, move to the next step */
    $('.js-continue-to-enrol').on('click', function (e){
        e.preventDefault();

        if (!isValidDetails()) {
            $(this).addClass('error');
            return false;
        } else {

            $(this).removeClass('error');

            goToNextSection('.select-institute');
            toggleProgressBar(2);
        }

    });

    $($hcpDobDay, $hcpDobMonth, $hcpDobYear).on('change', function(e){
        $(this)
            .parent()
            .removeClass('incomplete').addClass('complete');

        $('.dob .error')
            .text('Date of birth incorrect, please re-enter')
            .fadeOut({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });
    });

    /* Multiple institutions can be selected */
    $('.js-add-institution').on('click', function(e){
        e.preventDefault();

        $searchWrapper.slideDown({
            duration: 500,
            easing: 'easeInOutExpo',
            queue: false
        });

        $(this).slideUp({
            duration: 200,
            easing: 'easeInOutExpo',
            queue: false
        });

    });

    /* Enrolment details validation.
    ** If succsessful, move to the next step */
    $('.js-request-enrolment').on('click', function (e){
        e.preventDefault();

        let $error = $('.validation--message.enrolment'),
            errMessage = setErrorMessage();

        if(errMessage != ''){
            $(this).addClass('error');

            $error
                .text(errMessage)
                .slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });
        }
        else{
            $(this).removeClass('error');

            $error
                .text('')
                .slideUp({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

            goToNextSection('.confirmation');
            toggleProgressBar(3);
        }

    });

    /* Call API to create account */
    $('.js-create-account').on('click', function(e){
        e.preventDefault();

        // Define where to display ajax errors
        let $this = $(this),
            $errorContainer = $this.parent().siblings('.server-errors__wrap'),
            $error = $('.validation--message.create-account'),
            isValid = true,
            enrolmentsError = setErrorMessage();

        if (!$agreePrivacy.prop('checked')) {
            toaster('You must agree to the Terms and Conditions and Privacy to continue.', 'error');

            $agreePrivacy.parent().addClass('error');
            isValid = false;
        }

        if(!isValidDetails()){
            $error.text('HCP Details - Please review inputs');
            $error.fadeIn();
            isValid = false;
        }

        if(enrolmentsError != ''){
            $error.text('Enrolment in Institutions - ' + enrolmentsError);
            $error.fadeIn();
            isValid = false;
        }

        if(isValid){
            $this.removeClass('error');
            $error.text('');
            $error.fadeOut();
        }else{
            $this.addClass('error');
            return false;
        }

        loader.fadeIn();

        dobParams = $hcpDobDay.val() == '' && $hcpDobMonth.val() == '' && $hcpDobYear.val() == '' ? null :
                            {
                                'Day' : $hcpDobDay.val(),
                                'Month' : $hcpDobMonth.val(),
                                'Year' : $hcpDobYear.val()
                            };

        dataParams = {
            'FirstEnrolInstitutionEmailId': $('#FirstEnrolInstitutionEmailId').val(),
            'FirstName': $hcpFirstName.val(),
            'LastName': $hcpLastName.val(),
            'Dob' : dobParams,
            'Gender': $hcpGender.val(),
            'PrimaryPhoneNumber': $hcpPrimaryNumber.val(),
            'Password': $hcpPassword.val(),
            'ConfirmPassword': $hcpVerifyPassword.val(),
            "InstitutionsToEnroll": enrolmentsList()
        };

        $.ajax({
            url: '/api/hcps/register',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            type: 'POST',
            headers: { __RequestVerificationToken: $registerHcpForm.find('input[name=__RequestVerificationToken]').val() },
            data: JSON.stringify(dataParams),
            success: function (data) {
                loader.fadeOut();
                window.location.href = data.href;
            },
            error: function (error) {
                displayErrors(error, $errorContainer );
                loader.fadeOut();
            }
        });
    });

    $('.js-jump-section').on('click', function (e) {
        e.preventDefault();

        if (isAnim) {
            return false;
        }

        let $this = $(this),
            $parent = $this.parent(),
            el;

        sectionInd = $parent.index();

        switch (sectionInd) {
            case 1:
                el = $('.form--register-hcp');
                break;
            case 2:
                el = $('.select-institute');
                break;
            case 3:
                el = $('.confirmation');
                break;
        }

        gsap.to(window, {duration: 1, 
            scrollTo: {
                y: el.offset().top - $header.outerHeight() - parseInt($header.css('top')),
                ease: "expo.inOut"
            },
            onComplete: function () {
                isAnim = false;
            }
        });
    });


    /* Set enrolment values for creating account*/
    let enrolmentsList = function(){

        let enrolments = [];

        $('.list-selected-institutions .selected-instition').each( function (){
            let $this = $(this),
                $obj = {};

            $obj.InstitutionId = $this.data('institution-id'),
            $obj.EmailAddress = $this.find('.InstituteEmailAddress').val(),
            $obj.EmployeeId = $this.find('.EmployeeId').val(),
            $obj.Role = $this.find('.HcpType option:selected').text();
            $obj.PhoneNumber = $this.find('.PhoneNumber').val();
            enrolments.push($obj);
        });

        return enrolments;
    }

    /* HCP Details validation */
    let isValidDetails = function(){

        _isInvalid = [];

        $requiredInputs.each( function(){

            if($(this).attr('required') && isFieldEmpty($(this))){

                displayInputError($(this), false);

                _isInvalid.push(0);
            }
        })

        if (!isFieldSame($hcpPassword, $hcpVerifyPassword)) {

            displayInputError($hcpVerifyPassword, false);

            _isInvalid.push(0);
        }

        // DOB is not mandatory
        if (!isDobEmpty()){

            if(isValidDob()){
                $hcpDobDay .parent().removeClass('incomplete');
                $hcpDobMonth.parent().removeClass('incomplete');
                $hcpDobYear.parent().removeClass('incomplete');

                $('.dob .error').fadeOut({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

            }else{
                $hcpDobDay.parent().addClass('incomplete');
                $hcpDobMonth.parent().addClass('incomplete');
                $hcpDobYear.parent().addClass('incomplete');

                $('.dob .error').fadeIn({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                _isInvalid.push(0);
            }
        }

        if (_isInvalid.length > 0)
            return false;
        else
            return true;
    }

    /* Check if mandatory inputs are valid.
    ** Define list of emails
    */
    let isValidEnrolment = function(){

        let $email = $('.selected-instition input[type="email"] '),
            $role = $('.selected-instition select'),
            $phoneNumber = $('.selected-instition .PhoneNumber')

        _isInvalid = [];
        var phoneRegEx = /^[0-9]{8,10}$/;

        $email.each( function (){
            if (!isValidEmail($(this).val()) || isFieldEmpty($(this))) {

                displayInputError($(this), false);

                _isInvalid.push(0);
            }

        });

        $role.each( function(){

            if(isFieldEmpty($(this))){

                displayInputError($(this), false);

                _isInvalid.push(0);
            }
        })

        $phoneNumber.each( function(){
            if(!isFieldEmpty($(this)) && !$(this).val().match(phoneRegEx)){
                displayInputError($(this), false);
                _isInvalid.push(0);
            }
        });


        if (_isInvalid.length > 0) {
            return false;
        } else {
            return true;
        }

    }

    /* Define error to display */
    let setErrorMessage = function(){
        let errMessage = '';

        if($('.selected-instition').length == 0)
            errMessage = 'Select at least one institution ';
        else if(!isValidEnrolment()){
            errMessage = 'Please review invalid inputs';
        }

        return errMessage;
    }

});
